module.exports = __webpack_public_path__ + "img/130.4198fc63.jpg";